import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import { CareerService } from './career.service';
import { Career, AIRecommendation, CareerRoundType, CareerRound } from '../../interfaces/career/career.interface';
import { CareerSearchParam } from '../../interfaces/career/career-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';

@Injectable({
    providedIn: 'root'
})
export class CareerMockService extends CareerService {

    private mockCareers: Career[] = [
        // BATCH123 - INST456
        {
            uniqueId: 'MAP123',
            careerUniqueId: 'CAR456',
            careerName: 'Full Stack Developer',
            batchUniqueId: 'BATCH123',
            batchName: '2024 CSE Batch',
            institutionUniqueId: 'INST456',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'Full Stack Developer',
            roleName: 'Full Stack Developer',
            status: 'ACTIVE',
            description: 'Responsible for developing both front-end and back-end components of web applications.',
            matchPercentage: 94,
            timeline: '12 Months',
            industryName: 'Software Engineering',
            targetCompanies: ['Google', 'Meta', 'Netflix', 'Atlassian', 'Stripe'],
            skillsGap: {
                total: 100,
                completed: 65,
                details: [
                    { name: 'System Design', percentage: 45 },
                    { name: 'Node.js Architecture', percentage: 80 },
                    { name: 'Angular Advanced', percentage: 70 },
                    { name: 'Database Optimization', percentage: 55 }
                ]
            },
            stages: [
                {
                    stageKey: 'stage-1',
                    name: 'Foundational Intelligence',
                    description: 'Initial screening to assess core analytical and programming capabilities.',
                    orderNo: 1,
                    active: true,
                    assessments: [
                        { 
                            uniqueId: 'ass-1', 
                            name: 'Advanced Aptitude Matrix', 
                            type: 'APTITUDE', 
                            orderNo: 1, 
                            noOfQuestions: 30, 
                            eta: 45, 
                            score: 100, 
                            price: 0, 
                            experiencePoint: 50, 
                            retakeLimit: 3, 
                            active: true,
                            assessmentTopics: [
                                { name: 'Quantitative Reasoning' },
                                { name: 'Logical Deduction' }
                            ]
                        }
                    ]
                },
                {
                    stageKey: 'stage-2',
                    name: 'Technical Proficiency',
                    description: 'Deep dive into full-stack architecture and problem solving.',
                    orderNo: 2,
                    active: true,
                    assessments: [
                        { 
                            uniqueId: 'ass-2', 
                            name: 'System Design & Scalability', 
                            type: 'ONLINE_INTERVIEW', 
                            orderNo: 2, 
                            noOfQuestions: 20, 
                            eta: 60, 
                            score: 200, 
                            price: 1500, 
                            experiencePoint: 150, 
                            retakeLimit: 1, 
                            active: true,
                            assessmentTopics: [
                                { name: 'Microservices Architecture' },
                                { name: 'Load Balancing' },
                                { name: 'Caching Strategies' }
                            ]
                        },
                        { 
                            uniqueId: 'ass-3', 
                            name: 'Algorithm Masterclass', 
                            type: 'CODING_ROUND', 
                            orderNo: 3, 
                            noOfQuestions: 3, 
                            eta: 120, 
                            score: 300, 
                            price: 500, 
                            experiencePoint: 200, 
                            retakeLimit: -1, 
                            active: true,
                            assessmentTopics: [
                                { name: 'Graph Theory' },
                                { name: 'Dynamic Programming' }
                            ]
                        }
                    ]
                }
            ],
            rounds: []
        },
        {
            uniqueId: 'MAP124',
            careerUniqueId: 'CAR457',
            careerName: 'Backend Engineer',
            batchUniqueId: 'BATCH123',
            batchName: '2024 CSE Batch',
            institutionUniqueId: 'INST456',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'Backend Engineer',
            roleName: 'Backend Developer',
            status: 'ACTIVE',
            description: 'Focus on server-side logic, database management, and API development.',
            matchPercentage: 88,
            timeline: '6 Months',
            industryName: 'Software Development'
        },
        {
            uniqueId: 'MAP125',
            careerUniqueId: 'CAR458',
            careerName: 'Frontend Specialist',
            batchUniqueId: 'BATCH123',
            batchName: '2024 CSE Batch',
            institutionUniqueId: 'INST456',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'Frontend Specialist',
            roleName: 'UI/UX Developer',
            status: 'ACTIVE',
            description: 'Create engaging user interfaces and ensure seamless user experience across devices.',
            matchPercentage: 92,
            timeline: '6 Months',
            industryName: 'Software Development'
        },
        {
            uniqueId: 'MAP126',
            careerUniqueId: 'CAR459',
            careerName: 'Data Scientist',
            batchUniqueId: 'BATCH123',
            batchName: '2024 CSE Batch',
            institutionUniqueId: 'INST456',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'Data Scientist',
            roleName: 'Data Analyst',
            status: 'ACTIVE',
            description: 'Analyze complex data sets to drive business decisions and build predictive models.',
            matchPercentage: 85,
            timeline: '9 Months',
            industryName: 'Data Analytics'
        },
        {
            uniqueId: 'MAP127',
            careerUniqueId: 'CAR460',
            careerName: 'DevOps Architect',
            batchUniqueId: 'BATCH123',
            batchName: '2024 CSE Batch',
            institutionUniqueId: 'INST456',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'DevOps Architect',
            roleName: 'Infrastructure Engineer',
            status: 'ACTIVE',
            description: 'Manage cloud infrastructure, CI/CD pipelines, and ensure high availability.',
            matchPercentage: 90,
            timeline: '12 Months',
            industryName: 'Cloud Services'
        },
        // BATCH001 - INST001
        {
            uniqueId: 'MAP001-1',
            careerUniqueId: 'CAR501',
            careerName: 'Cloud Engineer',
            batchUniqueId: 'BATCH001',
            batchName: '2024 Alpha - Computer Science',
            institutionUniqueId: 'INST001',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'Cloud Engineer',
            roleName: 'Cloud Architect',
            status: 'ACTIVE',
            description: 'Design and implement cloud-native solutions using AWS/Azure.',
            matchPercentage: 82,
            timeline: '6 Months',
            industryName: 'Information Technology'
        },
        {
            uniqueId: 'MAP001-2',
            careerUniqueId: 'CAR502',
            careerName: 'Cybersecurity Analyst',
            batchUniqueId: 'BATCH001',
            batchName: '2024 Alpha - Computer Science',
            institutionUniqueId: 'INST001',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'Cybersecurity Analyst',
            roleName: 'Security Specialist',
            status: 'ACTIVE',
            description: 'Monitor and protect infrastructure from security threats.',
            matchPercentage: 75,
            timeline: '8 Months',
            industryName: 'Cybersecurity'
        },
        // BATCH002 - INST001
        {
            uniqueId: 'MAP002-1',
            careerUniqueId: 'CAR601',
            careerName: 'Mobile App Developer',
            batchUniqueId: 'BATCH002',
            batchName: '2024 Beta - Information Tech',
            institutionUniqueId: 'INST001',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'Mobile Developer',
            roleName: 'Flutter/React Native Developer',
            status: 'ACTIVE',
            description: 'Build cross-platform mobile applications for iOS and Android.',
            matchPercentage: 88,
            timeline: '4 Months',
            industryName: 'Mobile Development'
        },
        {
            uniqueId: 'MAP002-2',
            careerUniqueId: 'CAR602',
            careerName: 'UI Designer',
            batchUniqueId: 'BATCH002',
            batchName: '2024 Beta - Information Tech',
            institutionUniqueId: 'INST001',
            institutionName: 'ABC Engineering College',
            purchaseType: 'SUBSCRIPTION',
            purchaseStatus: 'ACTIVE',
            active: true,
            purchasedBy: 'admin@college.com',
            title: 'UI Designer',
            roleName: 'Product Designer',
            status: 'ACTIVE',
            description: 'Design intuitive user interfaces and create high-fidelity prototypes.',
            matchPercentage: 91,
            timeline: '3 Months',
            industryName: 'Design'
        }
    ];


    constructor() {
        super();
    }

    override findAll(searchParam: CareerSearchParam): Observable<PageResponse<Career>> {
        let filtered = [...this.mockCareers];

        if (searchParam.institutionUniqueId) {
            // In mock mode, we want to be lenient if the batch ID matches
            const hasBatchMatch = searchParam.batchUniqueId && this.mockCareers.some(c => c.batchUniqueId === searchParam.batchUniqueId);
            
            if (!hasBatchMatch) {
                filtered = filtered.filter(c => c.institutionUniqueId === searchParam.institutionUniqueId);
            }
        }

        if (searchParam.batchUniqueId) {
            filtered = filtered.filter(c => 
                c.batchUniqueId === searchParam.batchUniqueId || 
                c.batchUniqueId === 'BATCH123' ||
                c.batchUniqueId === 'BATCH001' // Added default fallback for demo
            );
        }

        if (searchParam.searchTerm) {
            const term = searchParam.searchTerm.toLowerCase();
            filtered = filtered.filter(c =>
                (c.title?.toLowerCase().includes(term)) ||
                (c.careerName?.toLowerCase().includes(term)) ||
                (typeof c.targetCompanies === 'string' && c.targetCompanies.toLowerCase().includes(term)) ||
                (Array.isArray(c.targetCompanies) && c.targetCompanies.some(comp => comp.toLowerCase().includes(term))) ||
                (c.industryName?.toLowerCase().includes(term)) ||
                (c.roleName?.toLowerCase().includes(term))
            );
        }

        const size = searchParam.size || 10;
        const page = searchParam.page || 0;

        const start = page * size;
        const end = start + size;

        const paginatedContent = filtered.slice(start, end);

        return this.wrapRequest(
            of({
                content: paginatedContent,
                page: {
                    number: page,
                    size: size,
                    totalElements: filtered.length,
                    totalPages: Math.ceil(filtered.length / size)
                }
            }).pipe(delay(1000)),
            false,
            'Failed to fetch careers'
        );
    }

    override find(careerUniqueId: string): Observable<Career> {
        const career = this.mockCareers.find(c => c.careerUniqueId === careerUniqueId);
        return this.wrapRequest(
            of(career!).pipe(delay(1000)),
            false,
            'Failed to fetch career'
        );
    }

    override create(data: Partial<Career>): Observable<Career> {
        const newCareer = { ...data, careerUniqueId: 'car-' + Math.random().toString(36).substring(7) } as Career;
        this.mockCareers.push(newCareer);

        return this.wrapRequest(
            of(newCareer).pipe(delay(1500)),
            false,
            'Failed to create career'
        );
    }

    override update(careerUniqueId: string, data: Partial<Career>): Observable<Career> {
        const index = this.mockCareers.findIndex(c => c.careerUniqueId === careerUniqueId);
        if (index !== -1) {
            this.mockCareers[index] = { ...this.mockCareers[index], ...data } as Career;
        }
        return this.wrapRequest(
            of(this.mockCareers[index]).pipe(delay(1500)),
            false,
            'Failed to update career'
        );
    }

    override delete(careerUniqueId: string, institutionUniqueId?: string): Observable<void> {
        this.mockCareers = this.mockCareers.filter(c => c.careerUniqueId !== careerUniqueId);
        return this.wrapRequest(
            of(undefined).pipe(delay(1000)),
            false,
            'Failed to delete career'
        );
    }

    override getTrendingCareers(): Observable<Career[]> {
        // Return top 3 careers as mock trending careers
        const trendingCareers = this.mockCareers.slice(0, 4);
        return this.wrapRequest(
            of(trendingCareers).pipe(delay(1000)),
            false,
            'Failed to fetch trending careers'
        );
    }

    override getAIRecommendation(): Observable<AIRecommendation> {
        const mockRecommendation: AIRecommendation = {
            profileSummary: 'Based on your current profile: Senior Associate (2yr) • CSE • 78% Mock Score',
            matchedRoles: [
                {
                    title: 'Full Stack Engineer',
                    matchPercentage: 60,
                    reason: 'HIGH SYNERGY WITH REACT SKILL-SET'
                },
                {
                    title: 'Backend Specialist',
                    matchPercentage: 45,
                    reason: 'NEEDS OPTIMIZATION IN SQL/DB'
                },
                {
                    title: 'DevOps Engineer',
                    matchPercentage: 25,
                    reason: 'GROWTH OPPORTUNITY IN CLOUD'
                }
            ],
            assessmentStatus: {
                remainingAssessmentsToUnlock: 2
            }
        };

        return this.wrapRequest(
            of(mockRecommendation).pipe(delay(1000)),
            false,
            'Failed to fetch AI recommendations'
        );
    }

    override getRounds(careerUniqueId: string): Observable<CareerRound[]> {
        const career = this.mockCareers.find(c => c.careerUniqueId === careerUniqueId);
        return this.wrapRequest(
            of(career?.rounds || []).pipe(delay(800)),
            false,
            'Failed to fetch rounds'
        );
    }

    override createRound(careerUniqueId: string, data: Partial<CareerRound>): Observable<CareerRound> {
        const career = this.mockCareers.find(c => c.careerUniqueId === careerUniqueId);
        const newRound = { ...data, uniqueId: Math.random().toString(36).substring(7) } as CareerRound;
        if (career) {
            career.rounds = [...(career.rounds || []), newRound];
        }
        return this.wrapRequest(
            of(newRound).pipe(delay(1000)),
            false,
            'Failed to create round'
        );
    }

    override updateRound(careerUniqueId: string, roundUniqueId: string, data: Partial<CareerRound>): Observable<CareerRound> {
        const career = this.mockCareers.find(c => c.careerUniqueId === careerUniqueId);
        let updatedRound: CareerRound | undefined;
        if (career && career.rounds) {
            const index = career.rounds.findIndex(r => r.uniqueId === roundUniqueId);
            if (index !== -1) {
                career.rounds[index] = { ...career.rounds[index], ...data };
                updatedRound = career.rounds[index];
            }
        }
        return this.wrapRequest(
            of(updatedRound!).pipe(delay(1000)),
            false,
            'Failed to update round'
        );
    }

    override assignInstitution(careerUniqueId: string, institutionUniqueId: string): Observable<void> {
        return this.wrapRequest(
            of(undefined).pipe(delay(800)),
            false,
            'Failed to assign institution'
        );
    }

        override findBatchCareersAll(searchParam: CareerSearchParam): Observable<PageResponse<Career>> {
        const filteredCareers = this.mockCareers.filter(c => c.batchUniqueId === searchParam.batchUniqueId && c.institutionUniqueId === searchParam.institutionUniqueId);
        const pageResponse = {
            content: filteredCareers,
            page: {
                number: 0,
                size: filteredCareers.length,
                totalElements: filteredCareers.length,
                totalPages: 1
            }
        };
        return this.wrapRequest(
            of(pageResponse as PageResponse<Career>).pipe(delay(1000)),
            false,
            'Failed to fetch batch careers'
        );
    }
}
